import { session } from '$lib/stores';

export const analytics = {
  track: ({
    name,
    props = {},
    options = {}
  }: {
    name: string;
    props?: Record<string, unknown>;
    options?: Record<string, unknown>;
  }) => {
    try {
      window?.gtag?.('event', name, props);
      return { success: true, name };
    } catch (error) {
      return { success: false, error };
    }
  },
  page: ({ category, props = {} }: { category?: string; props?: Record<string, unknown> }) => {
    try {
      window?.gtag?.('event', 'page_view', {
        page_title: document.title,
        page_location: location.href,
        route_id: category,
        ...props
      });
      return { success: true };
    } catch (error) {
      return { success: false, error };
    }
  }
};

export function getUserType() {
  let type = 'guest';
  const { irkAccount } = session.get();
  if (irkAccount?.roles?.includes('staff')) {
    type = 'staff';
  } else if (irkAccount?.metafyPartner) {
    type = 'pro';
  } else if (irkAccount) {
    type = 'user';
  }

  return type;
}
